import React from 'react';

import styles from '../../TaskTypeField.module.scss';

export default function EventFieldLayoutWeb() {
  return (
    <span className={`${styles.field} ${styles.event}`}>
      &nbsp;
    </span>
  );
}
